import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const undo = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    feature: null,
    lastSwatchApplied: {},
    previousSwatch: [],
    previousRecipe: {},
    hasUndoBeenApplied: false,
    components: null,
  },
};

export default undo;